import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {ProductTileProps} from '../../../features/ProductTile/ProductTile';
import {AddToBasketPayload} from '../../../features/ProductTile/types';
import {RecommendationsSkeleton} from '../Recommendations/Recommendations.skeleton';
import {useComplementaryRecommendation} from '../hooks/useGetBasketPageSection';
import {ComplementaryRecommendationView} from './ComplementaryRecommendationView';

export interface ComplementaryRecommendationProps {
  onClickAddToBasket: (productTile: AddToBasketPayload | undefined) => void;
  smallerPaddings?: boolean;
  ProductTileComponent?: React.FC<ProductTileProps>;
  compactMode?: boolean;
  addToCTALabel?: string;
}

export const ComplementaryRecommendation = ({
  onClickAddToBasket,
  smallerPaddings,
  compactMode,
  ProductTileComponent,
  addToCTALabel,
}: ComplementaryRecommendationProps) => {
  return (
    <>
      <DataFetcher
        request={useComplementaryRecommendation()}
        Error={() => null}
        View={ComplementaryRecommendationView}
        disableLoadingInIdleState
        Loading={RecommendationsSkeleton}
        viewProps={{
          onClickAddToBasket,
          smallerPaddings,
          ProductTileComponent,
          compactMode,
          addToCTALabel,
        }}
      />
    </>
  );
};
